import { Link } from "react-router-dom";
import { Container } from "reactstrap";
import { Href } from "../../constants";
import { ContainerClassMap, HeaderClassMap } from "../../data/layout/Header";
import { useAppSelector } from "../../reduxToolkit/hooks";
import UsePathName from "../../utils/UsePathName";
import Navigation from "./navigation";
import TopBar from "./TopBar";
import Location from "./location";
import UserActions from "./userActions";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

const Header = () => {
  const [Path] = UsePathName();
  const headerRef = useRef<HTMLElement>(null);
  const location = useLocation();

  const { sidebarOpen } = useAppSelector((state) => state.layout);

  const isJobOrProperty = ["job-2", "job-3", "property-2"].some((item) => Path?.includes(item));
  const isTopBar = ["car-2", "property-2"].some((item) => Path?.includes(item));

  useEffect(() => {
    const handleScroll = () => {
      if (headerRef.current) {
        if (window.scrollY > 50) {
          headerRef.current.classList.add("scrolled");
        } else {
          headerRef.current.classList.remove("scrolled");
        }
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);
  
  return (
    <header ref={headerRef} className={`px-0${HeaderClassMap[Path || ""] || ""}`} id="header">
      {isTopBar && <TopBar part={Path} />}
      <Container className={ContainerClassMap[Path || ""] || ""}>
        <div className="header-flex">
          <Location part={Path} isJobOrProperty={isJobOrProperty} />
          <Navigation />
          {/* <UserActions part={Path} isJobOrProperty={isJobOrProperty} /> */}
        </div>
      </Container>
      <Link to={Href} className={`overlay${sidebarOpen ? " overlay--active" : ""}`} />
    </header>
  );
};

export default Header;
